var ARFramedImage = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ar-company-logo-image',
    _vm.hasShadow && 'shadowed' ],attrs:{"ar-widget-id":"ar-framed-image","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-framed-image"}},[_c('div',{staticClass:"inner-frame",style:({
      backgroundImage: ("url('" + _vm.src + "')"),
    })})])},
staticRenderFns: [],
  props: {
    arWidgetMeta: String,
    src: {
      type: String,
      required: true,
    },
    hasShadow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `src=${this.src};`,
      ].join('');
    },
  },
};

export default ARFramedImage;
